import type { ArticleMeta } from "@/content/shared/article";
import { STATS } from "@/lib/constants";

export type BlogContentPost = ArticleMeta;

export const BLOG_POSTS: BlogContentPost[] = [
  {
    slug: "scrape-javascript-heavy-websites-without-getting-blocked",
    category: "Guide",
    title: "How to reliably scrape JavaScript-heavy websites at scale in 2025",
    excerpt:
      "A step-by-step technical guide to handling SPAs, dynamic content, and large-scale data collection using headless browsers and rotating proxies. We cover Playwright, Puppeteer, and the optimal proxy rotation strategies for each.",
    author: "Alex R.",
    authorInitial: "A",
    date: "Mar 18, 2025",
    readTime: "8 min read",
    tags: ["Web Scraping", "JavaScript", "Proxies"],
  },
  {
    slug: "mobile-proxy-vs-residential-proxy",
    category: "Tutorial",
    title: "Mobile proxy vs residential proxy: which one should you use?",
    excerpt:
      "We break down the key differences, use cases, and performance benchmarks to help you choose the right proxy type for your workflow.",
    author: "Lena K.",
    authorInitial: "L",
    date: "Mar 12, 2025",
    readTime: "5 min read",
    tags: ["Mobile Proxies", "Residential"],
  },
  {
    slug: "top-7-proxy-providers-compared",
    category: "Research",
    title: "Top 7 proxy providers compared: success rates, pricing, and coverage",
    excerpt:
      "We tested 7 major proxy providers over 30 days across 200+ targets. Here are the raw results — no sponsored rankings, just data.",
    author: "Marcus T.",
    authorInitial: "M",
    date: "Mar 5, 2025",
    readTime: "12 min read",
    tags: ["Comparison", "Benchmarks"],
  },
  {
    slug: "web-data-pipeline-llm-fine-tuning-python",
    category: "AI",
    title: "Building a web data pipeline for LLM fine-tuning with Python",
    excerpt:
      "Learn how to collect, clean, and format web data at scale for training language models — from proxy setup to data schema design.",
    author: "Yuki A.",
    authorInitial: "Y",
    date: "Feb 28, 2025",
    readTime: "10 min read",
    tags: ["LLM", "Python", "Data Pipeline"],
  },
  {
    slug: "introducing-proxy-builder-2",
    category: "Announcement",
    title: "Introducing Proxy Builder 2.0: sub-users, quotas, and live analytics",
    excerpt:
      "Today we're launching major updates to Proxy Builder — including team sub-accounts, per-user bandwidth limits, and a real-time analytics dashboard.",
    author: "Proxidize Team",
    authorInitial: "P",
    date: "Feb 19, 2025",
    readTime: "4 min read",
    tags: ["Product Update", "Proxy Builder"],
  },
  {
    slug: "rotating-proxies-in-python",
    category: "Guide",
    title: "Rotating proxies in Python: a complete Requests & HTTPX tutorial",
    excerpt:
      "From basic rotation to session-pinning and retry logic — everything you need to handle proxies gracefully in Python HTTP clients.",
    author: "Alex R.",
    authorInitial: "A",
    date: "Feb 10, 2025",
    readTime: "7 min read",
    tags: ["Python", "Tutorial", "Rotation"],
  },
  {
    slug: "captcha-bypass-strategies-2025",
    category: "Research",
    title: "CAPTCHA bypass strategies in 2025: what actually works",
    excerpt:
      "We analyzed 14 CAPTCHA implementations across major platforms and tested 6 bypass approaches. Here's what the data says.",
    author: "Marcus T.",
    authorInitial: "M",
    date: "Jan 29, 2025",
    readTime: "9 min read",
    tags: ["CAPTCHA", "Anti-bot", "Research"],
  },
  {
    slug: "ai-teams-proxies-web-data-collection",
    category: "AI",
    title: "How AI teams use proxies for large-scale web data collection",
    excerpt:
      "A look at real infrastructure patterns used by ML teams to collect training data at scale — bandwidth optimization, deduplication, and cost models.",
    author: "Yuki A.",
    authorInitial: "Y",
    date: "Jan 20, 2025",
    readTime: "6 min read",
    tags: ["AI", "Data Collection", "Infrastructure"],
  },
  {
    slug: "puppeteer-cluster-residential-proxy-rotation",
    category: "Tutorial",
    title: "Setting up a Puppeteer cluster with residential proxy rotation",
    excerpt:
      "Scale your headless browser scraping jobs with a Puppeteer cluster that automatically rotates residential proxies per request.",
    author: "Lena K.",
    authorInitial: "L",
    date: "Jan 12, 2025",
    readTime: "11 min read",
    tags: ["Puppeteer", "Node.js", "Clustering"],
  },
  {
    slug: "proxidize-covers-195-countries-200m-ips",
    category: "Announcement",
    title: `Proxidize now covers ${STATS.countries} countries with ${STATS.ips} real IPs`,
    excerpt:
      "Our network expansion is complete. We now offer the widest geographic coverage in the industry — backed by tier-1 mobile networks worldwide.",
    author: "Proxidize Team",
    authorInitial: "P",
    date: "Dec 30, 2024",
    readTime: "3 min read",
    tags: ["Network", "Coverage", "Announcement"],
  },
  {
    slug: "enterprise-proxy-setup",
    category: "Guide",
    title: "Enterprise proxy setup: VPN bypass, firewall rules, and SSO integration",
    excerpt:
      "How to deploy Proxidize in enterprise environments with strict network policies, including Active Directory SSO and compliance logging.",
    author: "Alex R.",
    authorInitial: "A",
    date: "Dec 18, 2024",
    readTime: "14 min read",
    tags: ["Enterprise", "Security", "VPN"],
  },
  {
    slug: "state-of-web-scraping-2025",
    category: "Research",
    title: "The state of web scraping in 2025: industry survey results",
    excerpt:
      "We surveyed 1,200+ developers and data engineers about their scraping stacks, challenges, and spend. Here's what we learned.",
    author: "Marcus T.",
    authorInitial: "M",
    date: "Dec 5, 2024",
    readTime: "8 min read",
    tags: ["Survey", "Industry", "2025"],
  },
];
